export default 'ssr-boost';
